
import React, { useRef, useState, useEffect } from "react";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";





import { db } from "../config/firebase";


const urlParams = new URLSearchParams(window.location.search);
const currentDomain = urlParams.get("parentUrl");


function Chatfooter(props) {
    const [localdata, setlocaldata] = useState("");
  const [formValue, setFormValue] = useState("");
  const scrollref=useRef(null)

  const currentTime = new Date();
  let hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; 
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const month = String(currentTime.getMonth() + 1).padStart(2, "0"); // +1 because getMonth() is 0-indexed
  const day = String(currentTime.getDate()).padStart(2, "0");
  const year = currentTime.getFullYear();
  const currentTimeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
  const seconds = currentTime.getSeconds();

  const date_string= `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
  const { isLoading, setIsLoading, setShowChatHistory, setStartNewChat, startNewChat } =
    props;
 
  let photoURL = "testing";
  function getCurrentISTDate() {
    const date = new Date();

    // Convert the current date to IST by adding the IST offset
    const utcOffset = date.getTimezoneOffset(); // Offset in minutes
    const istOffset = 330; // IST offset in minutes (UTC+5:30)
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);

    // Get the year, month, and day
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
}
useEffect(()=>{
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if(scrollref.current && !isMobile){
    scrollref.current.focus()
  }
}, [])

console.log("IS loading ---------------",isLoading);
useEffect(() => {
  if (startNewChat) {
    const data_var=currentDomain+"myData"
 
    localStorage.removeItem(data_var);
    // setStartNewChat(false);  // Set startNewChat back to false
  }
}, [startNewChat, setStartNewChat]); 



  const handlechange = async (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentDomain = urlParams.get("parentUrl");
    const channel = urlParams.get("channel") || "Web";
     const shopId =
       currentDomain || "null";
       
// Helper function to set cookies with 30-day expiration
function setCookie(name, value, days = 30) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length)); // 👈 decode here
    }
  }
  return null;
}

// Your modified code
const uidvar = currentDomain + "uid";
let uid = getCookie(uidvar) || "";

e.preventDefault();
var docid = "";
const data_var = currentDomain + "myData";
const storedData = getCookie(data_var);

if (!formValue) return;

setIsLoading(true);
setFormValue("Replying...");

if (!storedData) {
    // If the data is not already stored, set the initial data
    const initialData = { key: uid + Date.now().toString() };
    
    setCookie(data_var, JSON.stringify(initialData));
    
    docid = initialData.key;
} else {
    // If the data is already stored, parse it
    const parsedData = JSON.parse(storedData);
    
    docid = parsedData.key;
}

    const newarray = [
      {
        server: false,
        text: formValue,
        photoURL: "icon.png",
        uid: uid,
        time: currentTimeString,
        timestamp: Date.now(),
      },
    ];
    props.messageupdate(newarray);
    const docRef = doc(db, "Messages", docid);
    // Use addDoc to add a new document to the "users" collection
    const docSnap = await getDoc(docRef);
    let assigned_to="bot@krunk.ai"
    if (docSnap.exists()) {
      
      var message = docSnap.data().Messages;
      assigned_to= docSnap.data().assigned_to ;
      var lastmessage2 = message[message.length - 1];
      if (lastmessage2["server"] !== undefined) {
        message.push({ user: formValue,user_timestamp:date_string, time: currentTimeString });
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated:serverTimestamp(),
          
        }, { merge: true });
      } else {
        message.push({ user: formValue,user_timestamp:date_string, time: currentTimeString });
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated:serverTimestamp(),
        }, { merge: true });
      }


      
    } else {
      // docSnap.data() will be undefined in this case
      
      await setDoc(docRef, {
        Chat_Status:"Open",
        Fetch_Firestore:true,
        Messages: [{server:"Hello, how can I help you?",server_timestamp:date_string},{ user: formValue,user_timestamp:date_string, time: currentTimeString }],
        server: false,
        user_id: uid,
        shop_id: shopId,
        User_Channel: "Web",
        timestamp: Date.now(),
        photoURL,
        ticket_id:docid,
        assigned_to:"bot@krunk.ai",
        doc_id:docid,
        User_Timestamp:getCurrentISTDate(),
        created_at:serverTimestamp(),
        last_updated:serverTimestamp(),
      }, { merge: true });
    }
 
    var url=""
  
    if(shopId == "null"){
      //  url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
      url='http://127.0.0.1:8080/server?docid='+docid+"&shop_id="+"Krunk.ai";
      
      // url='https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
    }
   else if(shopId == "Krunk.ai"){
      // 
    url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+docid+"&shop_id="+"Krunk.ai";
    }
else    if(shopId== "HomesterOnboardingProperties"){
 url='https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"Krunk.ai";
    }
  else  if(shopId == "JustWravels")
   {
      url='https://justwravel-bot-code.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
    // url = "http://127.0.0.1:8080/server?docid="+  docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
   }
  else   if(shopId == "DivineHindu")
   {
    url='https://divine-hindu-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
   }
// else   if(shopId == "smilenbeauty"){
//      url='https://smile-n-beauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
//    }
else    if(shopId=="YaanMan"){
          url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
       
        }
        if(shopId == "smilenbeauty"){
 url='https://test-smilenbeauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid;
       
        }
        if(shopId == "headsupfortails.myshopify.com"){
          // url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;
        url="http://127.0.0.1:8080/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;

        }
        else{
            //  url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
  // url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;
      // url='https://justwravel-bot-code.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${formValue} `;
     url="http://127.0.0.1:8080/server?docid="+ docid+ "&shop_id=headsupfortails.myshopify.com&user_message="+`${formValue} `;
url='https://test-smilenbeauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid;
  
}
    // const url="https://version-2-llm-371280248581.asia-south1.run.app/"+docid;
    //  const url = "http://127.0.0.1:8080/" + docid;
    //  let url = "https://chat-app-art-w4axif2xma-el.a.run.app/" + docid;
    // let url=""
     const parenturl = urlParams.get('parentUrl')?.trim().toLowerCase();
    //  const allowedUrls = ["test.gamenation", "gamenation.in","gradcapital","cottoncandywala.in"];
    //  console.log(parenturl)

     
    //  if(parenturl ){
    //   url="https://whatsappbot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/?docid="+docid+"&shop_id="+parenturl;
    // }
    //  if (channel && channel.trim().toLowerCase() === "shopify") {
    //   url = "https://shopify-backend-371280248581.asia-south1.run.app/" + docid;
    // }
      if(assigned_to == "bot@krunk.ai"){
          fetch(url,{ method: 'GET'})
      .then((hello) => {
        console.log("URL is fetched");
      })
      .catch((err) => {
        console.log("No check");
      })
      .finally(() => {
        setIsLoading(false);
        setFormValue("");
      });
    }



   

    e.preventDefault();

    // setIsLoading(false);
  };

return (
  <div className=" krunk-text-textcolor  krunk-mt-0 krunk-px-2 krunk-pt-1 krunk-rounded-b-xl">
    <div className="krunk-flex krunk-items-center krunk-mt-0 krunk-justify-between krunk-gap-2 krunk-border-2 krunk-border-buttonbackground krunk-rounded-lg krunk-p-1 ">
      {/* <img src="https://krunk.ai/image_assets/home.svg" className="krunk-w-5 krunk-h-9" /> */}
      <form
        className="krunk-flex krunk-items-center krunk-justify-between krunk-px-1 krunk-rounded-lg krunk-w-full krunk-bg-white"
        onSubmit={handlechange}
      >
        <input
          type="text"
          className="krunk-outline-none krunk-bg-transparent krunk-text-sm krunk-w-full krunk-h-8 krunk-text-black krunk-placeholder:text-sm krunk-px-3 krunk-disabled:pointer-events-none krunk-disabled:text-gray-400"
          placeholder="Ask me anything"
          onChange={(e) => setFormValue(e.target.value)}
          value={formValue}
          disabled={isLoading}
          ref={scrollref}
        />
        
   
          <button
            type="submit"
           className="krunk-w-[60px] krunk-flex krunk-items-center krunk-justify-center krunk-bg-gray-200 krunk-rounded-xl krunk-h-8 krunk-disabled:opacity-65 krunk-mr-1"

            disabled={isLoading}
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="krunk-w-4 krunk-h-4"
            >
              <path 
                d="M12 4L12 20M12 4L18 10M12 4L6 10" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
       
      </form>
    </div>
    
    <div className="krunk-flex krunk-items-center krunk-justify-center krunk-gap-1 krunk-text-xs krunk-pt-1 krunk-pb-0">
      <h1>
        <span className="krunk-text-headertextcolor">Powered by</span>{" "}
        <span className="krunk-text-headertextcolor ">Krunk.ai</span>{" "}
      </h1>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FLogo.svg?alt=media&token=5e4d9440-9ded-426e-be00-e82624f1b6f2"
        alt=""
        className="krunk-w-4"
      />
    </div>
  </div>
);
}

export default Chatfooter;